import React, { Component } from 'react';
import { dispatch, IRootDispatch, IRootState, state } from '../../../../stores/rematch/root-store';
import { connect } from 'react-redux';
import { TransportAttendanceType } from '../../../../utilities/enum-utils';
import ActionModal, { ActionModalFooter } from '../../../../common-components/modal/ActionModal';
import { Paragraph } from '../../../../common-components/typography';
import { GhostButton, PrimaryButton } from '../../../../common-components/buttons';
import { notification } from 'antd';

interface IRemoveTransportBookingCancellationChargeModalProps {
  isOpen: boolean;
  onClose: () => void;
  transportBooking: any;
  doChangeTransportBookingToCustomerCancelNoFee: typeof dispatch.groupBookingsStore.doChangeTransportBookingToCustomerCancelNoFee;
  selectedGroupBookingItem: typeof state.groupBookingsStore.selectedGroupBookingItem;
  attendanceType: TransportAttendanceType;
}

interface IRemoveTransportBookingCancellationChargeModalState {
  step: number;
  title: string;
  canManuallyClose: boolean;
}

class RemoveTransportBookingCancellationChargeModal extends Component<
  IRemoveTransportBookingCancellationChargeModalProps,
  IRemoveTransportBookingCancellationChargeModalState
> {
  state = {
    step: 1,
    title: 'Remove cancellation fee',
    canManuallyClose: true,
  };

  onCloseModal = () => {
    const { onClose } = this.props;
    this.setState({ step: 1, canManuallyClose: true, title: 'Remove cancellation fee' }, onClose);
  };

  onSubmit = async () => {
    const { transportBooking, selectedGroupBookingItem, attendanceType } = this.props;
    try {
      this.setState({ canManuallyClose: false });
      await this.props.doChangeTransportBookingToCustomerCancelNoFee({
        bookingId: selectedGroupBookingItem.bookingId,
        transportBookingId: transportBooking.attendanceId,
        attendanceType,
      });
      this.setState({ step: 2, canManuallyClose: true, title: 'Cancellation fee removed' });
    } catch (e) {
      this.setState({ canManuallyClose: true });
      notification.error({ message: 'Oops, something went wrong, please try again.' });
    }
  };

  renderView = () => {
    const { step } = this.state;
    if (step === 1) {
      return (
        <div className="anim-fade-in">
          <Paragraph>Are you sure you want to remove the cancellation fee for this booking?</Paragraph>

          <ActionModalFooter>
            <GhostButton className="mr-medium" size="large" onClick={this.onCloseModal}>
              Cancel
            </GhostButton>
            <PrimaryButton size="large" icon="check" onClick={this.onSubmit}>
              Remove cancellation fee
            </PrimaryButton>
          </ActionModalFooter>
        </div>
      );
    }

    if (step === 2) {
      return (
        <div className="anim-slide-right">
          <Paragraph>You have successfully removed the cancellation fee for this booking</Paragraph>

          <ActionModalFooter>
            <PrimaryButton size="large" onClick={this.onCloseModal}>
              Close
            </PrimaryButton>
          </ActionModalFooter>
        </div>
      );
    }
  };

  render() {
    let { isOpen } = this.props;
    const { title } = this.state;
    return (
      <ActionModal
        isOpen={isOpen}
        title={title}
        width="medium"
        onClose={this.onCloseModal}
        canCloseOutside={this.state.canManuallyClose}
        showCloseButton={this.state.canManuallyClose}
        verticalAlignment="highest"
      >
        <div>{this.renderView()}</div>
      </ActionModal>
    );
  }
}
const mapState = (state: IRootState) => ({
  selectedGroupBookingItem: state.groupBookingsStore.selectedGroupBookingItem,
});

const mapDispatch = (dispatch: IRootDispatch) => ({
  doChangeTransportBookingToCustomerCancelNoFee:
    dispatch.groupBookingsStore.doChangeTransportBookingToCustomerCancelNoFee,
});

export default connect(mapState, mapDispatch)(RemoveTransportBookingCancellationChargeModal);
